// eslint-disable-next-line no-restricted-imports
import instanceFactory from 'InstanceFactory';
import { contextHelpIds } from '@Common/Core/ContextHelpIds';

type TInstanceFactory = typeof instanceFactory;
type HelpUrlsStructure = {
    [T in keyof TInstanceFactory]?: Partial<{ [Prop in keyof TInstanceFactory[T]['types']]: string }>;
};

const { additionalRecordConfiguration } = contextHelpIds.studio;

export const helpUrls: HelpUrlsStructure = {
    RecordDocument: {
        rebuildIndexes: additionalRecordConfiguration
    },
    StandardMetric: {
        rebuildIndexes: additionalRecordConfiguration
    },
    EventExecutionStep: {
        rebuildIndexesMode: additionalRecordConfiguration
    },
    MetricExecutionStep: {
        rebuildIndexesMode: additionalRecordConfiguration
    }
};
